<!-- src/components/pages/es/LandingES.vue -->
<template>
  <div class="landing-page">
    <MenubarES :scrollToSection="scrollToSection" />

    <section id="perfil" ref="perfil"><PerfilES /></section>
    <section id="logros" ref="logros"><LogrosES /></section>
    <section id="servicios" ref="servicios"><ServiciosES /></section>
    <section id="trayectoria" ref="trayectoria"><TrayectoriaES /></section>
    <section id="beneficios" ref="beneficios"><BeneficiosEs /></section>
        <section id="portafolio" ref="portafolio"><PortafolioEs /></section>


    <FooterES />
    <ChatBotEA lang="ES" />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import MenubarES from '@/components/pages/es/menubarES.vue'

import PerfilES from '@/components/pages/es/perfilES.vue'
import LogrosES from '@/components/pages/es/LogrosES.vue'
import ServiciosES from '@/components/pages/es/ServiciosES.vue'
import TrayectoriaES from '@/components/pages/es/TrayectoriaES.vue'
import FooterES from '@/components/pages/es/footerES.vue'
import BeneficiosEs from '@/components/pages/es/BeneficiosEs.vue'
import ChatBotEA from '@/components/pages/es/ChatBotEA.vue'
import PortafolioEs from './portafolio.vue'

const perfil = ref(null)
const logros = ref(null)
const servicios = ref(null)
const trayectoria = ref(null)
const beneficios = ref(null)

// ✅ Definimos la función que estás pasando al Menubar
const scrollToSection = (id) => {
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const onScrollEvent = (e) => {
  const id = e.detail?.id
  if (!id) return
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

onMounted(async () => {
  window.addEventListener('scroll-to-section', onScrollEvent)

  // ✅ Mapeo correcto EN -> ES (incluye 'benefits')
  const saved = localStorage.getItem('scrollTarget')
  if (saved) {
    localStorage.removeItem('scrollTarget')
    await nextTick()
    const mapENtoES = {
      profile: 'perfil',
      about: 'logros',
      services: 'servicios',
      results: 'trayectoria',
            portafolio: 'portafolio',

      benefits: 'beneficios'
    }
    const id = mapENtoES[saved] || saved
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll-to-section', onScrollEvent)
})
</script>

<style scoped>
.landing-page { width: 100%; overflow-x: hidden; }
section { scroll-margin-top: 110px; } /* compensa header fijo del layout */
</style>
